class BrandHover {
  // #parentElement = document.querySelector(".brands-2-wrapper");
  #brandLogos = document.querySelectorAll(`.brand-logo img`);

  constructor() {
    this.addHandlerHover();
  }

  addHandlerHover() {
    ["mouseenter", "mouseleave"].forEach((ev) =>
      this.#brandLogos.forEach((logo) => {
        logo.addEventListener(ev, function () {
          this.classList.toggle("gray-filter");
        });
      })
    );
  }
}

export default new BrandHover();
